import { Box, Center, Flex, Image, Text } from '@chakra-ui/react';
import usePeCompanyColor from 'hooks/modules/pe/usePeCompanyColor';
import AppCard from 'presentation/components/shared/card/AppCard';
import TagsRow, { TagSize } from 'presentation/components/shared/TagsRow';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import PeOffersGridItemOrderBook from './PeOffersGridItemOrderBook';
import PeOffersGridItemProgress from './PeOffersGridItemProgress';

interface Props {
  offer: PeOfferListItem;
  onCardClick: () => void;
  onActionClick: () => void;
}

const PeOfferGridItem: FC<Props> = ({ offer, onActionClick, onCardClick }) => {
  const gap = 20;
  const bgColor = usePeCompanyColor(
    offer.company.color,
    offer.company.gradientColor
  );

  return (
    <AppCard
      cursor="pointer"
      onClick={onCardClick}
      w={`calc(50% - ${gap / 2}px)`}
      mb={`${gap}px`}
      key={offer.id}
      p="15px"
      display="flex"
      flexDir="column"
      justifyContent="space-between"
    >
      <Box>
        <Flex justifyContent="space-between" minH="60px">
          <Box flex="1">
            <Text noOfLines={2} fontSize="26px" fontWeight="700">
              {offer.name}
            </Text>
            {offer.subtitle && (
              <Text
                color={offer.subtitleColor ?? '#000'}
                noOfLines={1}
                mt="10px"
                fontSize="18px"
                fontWeight="700"
              >
                {offer.subtitle}
              </Text>
            )}
          </Box>
          <Flex
            justifyContent="center"
            alignItems="center"
            w="60px"
            h="60px"
            borderRadius="50%"
            background={bgColor}
          >
            {offer.logo && (
              <Image w="54px" h="54px" minW="54px" src={offer.logo.url} />
            )}
          </Flex>
        </Flex>
        {offer.shortDescription && (
          <Text mt="10px" noOfLines={2}>
            {offer.shortDescription}
          </Text>
        )}
        {offer.progress && (
          <Box mt="10px">
            <PeOffersGridItemProgress progress={offer.progress} />
          </Box>
        )}
        {offer.orderBook && (
          <Box mt="10px">
            <PeOffersGridItemOrderBook orderBook={offer.orderBook} />
          </Box>
        )}
        {offer.company.tags.length > 0 && (
          <Box mt="10px">
            <TagsRow tags={offer.company.tags} size={TagSize.small} />
          </Box>
        )}
      </Box>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          onActionClick();
        }}
        mt="18px"
        p="10px"
        bgColor={Color.Shade200}
        borderRadius="6px"
        cursor="pointer"
      >
        <Center>
          <Text noOfLines={1}>{offer.buttonText}</Text>
        </Center>
      </Box>
    </AppCard>
  );
};

export default PeOfferGridItem;
